<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="excmdevicetype_title"
        class="form-control-label">{{$t('views.excmdevicetype.form.title')}}:</label>
      <input
        id="excmdevicetype_title"
        v-model="item.title"
        :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('title', $event.target.value)">
      <div
        v-if="isInvalid('title')"
        class="invalid-feedback">{{ violations.title }}</div>
    </div>

    <template v-if="duplicates && duplicates.length > 0">
      <h6>{{$t('views.excmdevicetype.form.duplicates')}} ({{ duplicates.length }}):</h6>
      <b-row v-for="(duplicate, index) in duplicates" v-bind:key="'duplicate-' + index">
        <b-col cols="12">
          {{ duplicate.title }}
        </b-col>
        <b-col cols="12">
          <hr class="mt-1 mb-1">
        </b-col>
      </b-row>
    </template>

    <button
      type="submit"
      class="btn btn-success">
      <span v-if="duplicates && duplicates.length > 0">{{$t('buttons.duplicatesSubmit')}}</span>
      <span v-else>{{$t('buttons.submit')}}</span>
    </button>
    <b-btn v-if="openedInModal" @click="closeModal()" variant="danger">
      {{$t('buttons.close')}}
    </b-btn>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },

    openedInModal: {
      type: Boolean,
      default: false
    },

    duplicates: {
      type: Array,
      default: null
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    closeModal () {
      this.$store.state.modals.excmdevicetype.form.close = 1
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
